export default __webpack_public_path__ + "static/media/Flag_of_Singapore.2fdff6fb.svg";